import { inject } from "mobx-react";
import React from "react";
import {
  ListEntrySchema,
  ListEntrySchemaColumns,
  ReadOnlyListEntrySchema
} from "./schema";
import { CreateView, ShowView } from "lego-gui-lib/lib";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { isAllowed } from "../../../common/common";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";

const injectDataSource = (comp: any) =>
  inject("list", "listEntry", "i18n")(observer(comp));

export const CreateListEntry = injectDataSource(
  ({ list, listEntry, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", { domain: "hns:listEntry:domain" });
    const baseUrl = match.url;
    const parentTitle = i18n.t("common:edit", { domain: "hns:list:domain" });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const id = {
      id: match.params.entryId
    };
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <CreateView
          dataSource={listEntry.oneDataSource}
          {...rest}
          title={title}
          fields={ListEntrySchemaColumns}
          id={id.id ? id : undefined}
          goBack={() => history.goBack()}
        />
      </>
    );
  }
);

export const ShowListEntry = injectDataSource(
  ({ list, listEntry, i18n, match }: any) => {
    const allowed = isAllowed(list);
    const title = allowed
      ? i18n.t("common:edit", { domain: "hns:listEntry:domain" })
      : i18n.t("hns:listEntry:domain");
    const baseUrl = match.url;
    const id = {
      id: match.params.entryId
    };
    const parentTitle = allowed
      ? i18n.t("common:edit", { domain: "hns:list:domain" })
      : i18n.t("hns:list:domain");
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <ShowView
          dataSource={listEntry.oneDataSource}
          title={title}
          goBack={() => history.goBack()}
          fields={allowed ? ListEntrySchema : ReadOnlyListEntrySchema}
          hideDeleteButton={!allowed}
          id={id}
          onlyView={!allowed}
        />
      </>
    );
  }
);
